module.exports = __webpack_public_path__ + "static/img/scan.57ba185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scan.png
// module id = 1182
// module chunks = 0